import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { CloudwatchService } from '../../service';

export type AlarmActionsActivatedConfig = typeof AlarmActionsActivatedConfig._.Config;

export const AlarmActionsActivatedConfig = IntegrationConfig.make({
  service: CloudwatchService,
  name: Integration_Handler_Names_Enum.AlarmActionsActivated,
  configSchema: z.object({}),
});
